import { Injectable, signal } from '@angular/core';
import { ModulePermission } from '../interfaces/permission';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TEMPORARYPERMISSION } from '../enum/permission';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  tempPermission: ModulePermission[] = TEMPORARYPERMISSION;

  private modules = signal<ModulePermission[]>(this.tempPermission);

  updateModuleList(value: ModulePermission[]) {
    this.modules.set(value);
  }

  getModuleList() {
    return this.modules;
  }

  constructor(private http: HttpClient) { }

  public findModule(m_name: any) {
    const module: any = this.tempPermission.find((obj: any) => obj.vParentFeature == m_name);
    return module;
  }

  public checkModulePermission(m_name: any) {
    const currentModules = this.modules();
    const module:any = currentModules.find((obj:any)=>obj.vParentFeature==m_name);
    return module;
  }

  checkPermission(permission: any) {
    const currentModules = this.modules();
    const module = currentModules.find((module) => { return (permission == module.vParentFeature) })
    return module && module.hasChild === true && (module.iModuleStatus == 1 || module.iModuleStatus == 2) ? true : false;
  }

  GetParentFeatures(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization/v1/get-parent-features`;
    return this.http.post<any>(apiURL, data);
  }

  GetChildFeatures(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization/v1/get-child-features`;
    return this.http.post<any>(apiURL, data);
  }

  GetModuleList(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization/v1/get-module-list`;
    return this.http.post<any>(apiURL, data);
  }


}
